import Spline from "@splinetool/react-spline";
import "../../App.css";
export default function About({ onLoad }) {
  return (
    <Spline
      style={{ height: "60vh" }}
      scene="https://prod.spline.design/sYd92qsD19IWFu57/scene.splinecode"
      onLoad={onLoad}
    />
  );
}
